const shellQuote = (val) => {
  if (val === undefined || val === null) return "''";
  const s = typeof val === "string" ? val : JSON.stringify(val);
  return `'${s.replace(/'/g, "'\\''")}'`;
};

const buildCurl = (config) => {
  const baseURL = config.baseURL || "";
  const url = config.url || "";
  let fullUrl = url;
  if (!/^https?:\/\//i.test(url)) {
    const sep =
      baseURL.endsWith("/") || url.startsWith("/") || url === "" ? "" : "/";
    fullUrl = `${baseURL}${sep}${url}`;
  }

  if (config.params && typeof config.params === "object") {
    const qs = Object.entries(config.params)
      .filter(([, v]) => v !== undefined && v !== null)
      .map(
        ([k, v]) =>
          `${encodeURIComponent(k)}=${encodeURIComponent(
            typeof v === "object" ? JSON.stringify(v) : v,
          )}`,
      )
      .join("&");
    if (qs) fullUrl += (fullUrl.includes("?") ? "&" : "?") + qs;
  }

  const method = (config.method || "get").toUpperCase();
  const parts = [`curl -X ${method}`];

  const headers = { ...(config.headers || {}) };
  Object.keys(headers).forEach((k) => {
    const v = headers[k];
    if (v === undefined || v === null) return;
    if (typeof v === "object") return;
    parts.push(`-H ${shellQuote(`${k}: ${v}`)}`);
  });

  if (config.data !== undefined && config.data !== null) {
    let body = config.data;
    if (typeof body !== "string") {
      try {
        body = JSON.stringify(body);
      } catch {
        body = String(body);
      }
    }
    parts.push(`-d ${shellQuote(body)}`);
  }

  parts.push(shellQuote(fullUrl));
  return parts.join(" ");
};

export const logCurlForResponse = (response) => {
  if (!__DEV__ || !response?.config) return;
  const status = response.status;
  const duration = response.config.headers?.["request-duration"];
  // eslint-disable-next-line no-console
  console.log(
    `[API ${status}${duration != null ? ` ${duration}ms` : ""}] ${buildCurl(
      response.config,
    )}`,
  );
};

export const logCurlForError = (error) => {
  if (!__DEV__) return;
  const config = error?.config;
  if (!config) return;
  const status = error.response?.status || "ERR";
  // eslint-disable-next-line no-console
  console.log(`[API ${status}] ${buildCurl(config)}`);
};
